import { render, staticRenderFns } from "./SteffiCustomersOverview.vue?vue&type=template&id=b9a9a4e8&scoped=true&"
import script from "./SteffiCustomersOverview.vue?vue&type=script&lang=js&"
export * from "./SteffiCustomersOverview.vue?vue&type=script&lang=js&"
import style0 from "./SteffiCustomersOverview.vue?vue&type=style&index=0&id=b9a9a4e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a9a4e8",
  null
  
)

export default component.exports